<script>
import RequestFormStepper from "@/views/Requests/RequestFormStepper.vue"
import RequestForm from "@/views/Requests/RequestForm.vue"

export default {
  name: "RequestFormPage",
  components: {RequestForm, RequestFormStepper},
  computed: {
    userRole() {
      return this.$store.state.user?.claims?.role ?? null
    },
  }
}
</script>

<template>
  <RequestForm v-if="userRole === 'system'"></RequestForm>
  <RequestFormStepper v-else></RequestFormStepper>
</template>

<style scoped>

</style>